import { render, staticRenderFns } from "./OptionScale.vue?vue&type=template&id=5c16cd99&"
import script from "./OptionScale.vue?vue&type=script&lang=js&"
export * from "./OptionScale.vue?vue&type=script&lang=js&"
import style0 from "./OptionScale.vue?vue&type=style&index=0&id=5c16cd99&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports